    const name = JSON.parse(`["${localStorage.getItem("Role Name")?.toLocaleLowerCase().replace(/,/g, '","')}"]`);
    const  Roles = localStorage.getItem("Role Name") ? name[0] : "All"
    export default Roles